import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { BookerPlatformWrapperAtomPropsForTeam } from '@calcom/atoms/dist/packages/platform/atoms/booker/types';
import { localizationService } from '@shared-services/localization-service';
import { Booker } from '../../LazyBooker';
import calApi from '../../api';
import { logBookingError } from '../../loggingUtils';
import { isBookingValid } from '../../utils';
import CloseButton from '../CloseButton';
import { Modal } from '../Modal';

interface RescheduleModalProps {
    bookerProps: BookerPlatformWrapperAtomPropsForTeam;
    onClose: () => void;
}

const RescheduleModal = ({ bookerProps, onClose }: RescheduleModalProps) => {
    const [showRescheduleModal, setShowRescheduleModal] = useState(false);
    const { bookingUid, ...rest } = bookerProps;

    useEffect(() => {
        if (bookingUid) {
            calApi
                .getBooking(bookingUid)
                .then((bookingData) => {
                    if (isBookingValid(bookingData.status)) {
                        setShowRescheduleModal(true);
                    } else {
                        onClose();
                    }
                })
                .catch((err) => {
                    logBookingError(
                        'Failed to get booking data (reschedule flow)',
                        {
                            errorMessage: err.message,
                            additionalInfoToLog: {
                                ...bookerProps,
                                bookingUid,
                            },
                        }
                    );
                });
        }
    }, []);

    if (!showRescheduleModal) {
        return null;
    }

    return (
        <Modal
            width='65vw'
            header={
                <Header>
                    <span>
                        {localizationService.str(
                            'ui.runtimessr.calbooking.reschedule.booking'
                        )}
                    </span>
                    <CloseButton onClick={onClose} />
                </Header>
            }
            dataAuto='ssr-cal-booking-reschedule-modal'
        >
            <Wrapper>
                <Booker {...rest} rescheduleUid={bookingUid} />
            </Wrapper>
        </Modal>
    );
};

const Wrapper = styled.div`
    display: flex;
    flex-direction: column;
`;

const Header = styled.div`
    text-align: center;
    display: flex;
    flex-direction: column;
    height: 58px;
    background-color: #f5f5f7;
    line-height: 58px;
    position: relative;
    padding: 0 32px;
    font-weight: 550;
    font-size: 16px;
    span {
        width: fit-content;
    }
`;
export default RescheduleModal;
